export { default } from './card'
export type { CardProps } from './card'
